import { render, staticRenderFns } from "./inactiveClient.vue?vue&type=template&id=00c11adc&scoped=true"
import script from "./inactiveClient.vue?vue&type=script&lang=js"
export * from "./inactiveClient.vue?vue&type=script&lang=js"
import style0 from "./inactiveClient.vue?vue&type=style&index=0&id=00c11adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c11adc",
  null
  
)

export default component.exports